// Kurzbefehl-Token verwalten (Projektplan 10.4). Der Klartext-Token kommt
// vom Server genau einmal beim Anlegen zurueck, wie bei Sammlungs-
// einladungen (lib/collections.ts) - danach zeigt die Liste nur noch Label
// und Zeitstempel.

import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { api } from "./api.js";

export interface QuickAddToken {
  id: number;
  label: string;
  defaultTargets: number[];
  createdAt: string;
  lastUsedAt: string | null;
}

export function useQuickAddTokens() {
  return useQuery({
    queryKey: ["quick-add-tokens"],
    queryFn: async () => (await api<{ tokens: QuickAddToken[] }>("/quick-add-tokens")).tokens,
  });
}

export function useQuickAddTokenAnlegen() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (angaben: { label: string; defaultTargets: number[] }) =>
      api<{ id: number; label: string; token: string; url: string }>("/quick-add-tokens", {
        method: "POST",
        body: angaben,
      }),
    onSuccess: () => void queryClient.invalidateQueries({ queryKey: ["quick-add-tokens"] }),
  });
}

export function useQuickAddTokenWiderrufen() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => api<void>(`/quick-add-tokens/${id}`, { method: "DELETE" }),
    onSuccess: () => void queryClient.invalidateQueries({ queryKey: ["quick-add-tokens"] }),
  });
}
